import { useCallback, useContext, useEffect, useState } from "react";
import { Avatar, Badge, Col, Layout, Menu, Row } from "antd";

import {
  UserOutlined,
  BellOutlined,
  FileOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import UserContext from "../../providers/UserContext";
import NetworkApi from "../../network/networkApi";
import { Link } from "react-router-dom";
import AnnouncementModal from "./AnnouncementModal";

const { Header } = Layout;
const { SubMenu } = Menu;

const UserMenu = () => {
  const [current, changeCurrent] = useState("key");
  const { user } = useContext(UserContext);
  const [announcements, setAnnouncements] = useState<any[]>([]);
  const [announcementOpen, setAnnouncementOpen] = useState(false);
  useEffect(() => {
    NetworkApi.requestGet("/api/announcement/dashboard").then((response) => {
      if (response.resultCode === 200 && Array.isArray(response.result)) {
        setAnnouncements(response.result);
        if (response.result.length > 0) setAnnouncementOpen(true);
      }
    });
  }, []);
  const handleClick = (e: any) => {
    changeCurrent(e.key);
  };
  const logout = useCallback(async () => {
    await NetworkApi.requestGet("/api/auth/logout");
    window.location.href = "/";
  }, []);
  return (
    <Header>
      <Row justify={"space-between"}>
        <Col span={12}></Col>
        <Col span={12}>
          <Row justify={"end"} gutter={15}>
            <Col>
              <Menu
                onClick={handleClick}
                selectedKeys={[current]}
                mode="horizontal"
                theme={"dark"}
              >
                <Menu.Item key="notification">
                  <span onClick={() => setAnnouncementOpen(true)} style={{ cursor: "pointer" }}>
                    <Badge count={announcements.length} overflowCount={99}>
                      <Avatar icon={<BellOutlined />} />
                    </Badge>
                  </span>
                </Menu.Item>
                <SubMenu
                  key="SubMenu"
                  icon={<UserOutlined />}
                  title={`${user?.lastName} ${user?.firstName}`}
                >
                  <Menu.Item key="profile1">
                    <Link to={"/user/profile"}>Хувийн мэдээлэл</Link>
                  </Menu.Item>
                  <Menu.Item key="profile2">
                    <Link
                      target="_blank"
                      to={{
                        pathname:
                          "https://drive.google.com/drive/u/2/folders/1_zX7qnYbNO5vmG39RsqtwCSA3m895Qr-",
                      }}
                    >
                      <FileOutlined /> Систем ашиглах заавар
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="profile3">
                    <Link
                      target="_blank"
                      to={{
                        pathname: "https://www.youtube.com/watch?v=ZGRx2nB56Lg",
                      }}
                    >
                      <VideoCameraOutlined /> Бүртгүүлэх заавар
                    </Link>
                  </Menu.Item>
                  <Menu.Item onClick={logout} key="logout">
                    Гарах
                  </Menu.Item>
                </SubMenu>
              </Menu>
            </Col>
          </Row>
        </Col>
      </Row>
      <AnnouncementModal
        open={announcementOpen}
        announcements={announcements}
        onClose={() => setAnnouncementOpen(false)}
      />
    </Header>
  );
};
export default UserMenu;
